module.exports = __webpack_public_path__ + "static/fonts/Metric-R-medium.79df8f8.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/metric/Metric-R-medium.woff2
// module id = vFMk
// module chunks = 28